import { render, staticRenderFns } from "./add-new-primary-role.vue?vue&type=template&id=57681ddf&"
import script from "./add-new-primary-role.vue?vue&type=script&lang=ts&"
export * from "./add-new-primary-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports